import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject ,  Observable, Subscription } from 'rxjs';
import * as Store from '@core/redux/stores';
import { select, NgRedux } from '@angular-redux/store';
import { ModalService, ConfirmModalService, ProxyService, ErrorCodesService } from '@core/services';
import { OrderCheckInRequest, CheckInType, IAppState, Actions, OrderCheckInOption, PickupType, CheckInOptions, UserOrderInfo } from '@core/redux/stores';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
@Injectable({
  providedIn: 'root'
})
export class CheckInService implements OnDestroy {
  @select(appState => appState.submittedOrder) submittedOrder: Observable<Store.UserOrderInfo>;
  @select((appState) => appState.auth.isLoggedIn) isLoggedIn?: Observable<boolean>;
  order: Store.UserOrderInfo;
  checkInOption: CheckInOptions;
  private isUserLoggedIn: boolean;
  private subscriptions = new Subscription();  
  public loading = false;
  private spaceSetSubject = new BehaviorSubject<any>({space: undefined, expiration: undefined});
  public isSpaceSet$ = this.spaceSetSubject.asObservable();

  constructor(private modalService: ModalService, private confirmModalService: ConfirmModalService,
                private proxy: ProxyService, private ngRedux: NgRedux<IAppState>) {
    this.subscriptions.add(
      this.submittedOrder.subscribe(succ => {
      this.order = succ as Store.UserOrderInfo;      
  }));
  this.subscriptions.add(
    this.isLoggedIn.subscribe(
      (auth) => {
        this.isUserLoggedIn = auth ? auth : false;
      }
    ));
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  checkIn(orderCheckInRequest: OrderCheckInRequest) {
    this.loading = true;
    if (this.order && this.order.checkInInfo && this.order.checkInInfo.checkInIndicator) {
      // Already checked in - see if it is the same space
      if (this.order.checkInInfo.checkInIndicator === orderCheckInRequest.checkInIndicator) {
        // Checking in with the same space - do nothing
        this.hideModal();
        return;
      }
    }
    const endPoint = this.isUserLoggedIn ? ApiRoutes.ORDER_STATUS + this.order.orderNumber + '/check-in' :
                     '/meals/orders/' + this.order.orderNumber + '/guestuser/' + this.order.guid +  '/check-in';
    this.proxy.httpPost(endPoint, orderCheckInRequest).subscribe(
      (success: any) => {
        if (success && !success.body.success && success.body.error) {
          if (success.body.error.code === 8527) {
            this.showBreakfastModal();
          } else {
            this.getCheckinOptions(this.order).subscribe(response => {
              this.checkInOption = <CheckInOptions>response.body.valueOf();
              const errorMessage = ErrorCodesService.getErrorMessage(success.body.error.code, null);
              this.showErrorModal(errorMessage);
            }, error=> {
              console.log('Error getting checkin options', error);
              const errorMessage = ErrorCodesService.getErrorMessage(success.body.error.code, null);
              this.showErrorModal(errorMessage ?? 'Something went wrong. Please refresh your browser.');
            });            
          }
        } else if (success && success.body.success) {
          if (!this.order.checkInInfo && orderCheckInRequest?.checkInIndicator !== null) {
            this.order.checkInInfo = {isCheckInRequired: true, checkInIndicator: orderCheckInRequest?.checkInIndicator, checkInType: CheckInType.Curbside };
          }
          this.order.checkInInfo.checkInIndicator = orderCheckInRequest?.checkInIndicator;
          this.order.checkInInfo.checkInType = orderCheckInRequest?.checkInType;
          this.ngRedux.dispatch({ type: Actions.SUBMITTEDORDER, data: this.order });
          if(orderCheckInRequest.checkInType == CheckInType.Curbside || orderCheckInRequest.checkInType == CheckInType.Table) {
            this.isSpaceSet(orderCheckInRequest?.checkInIndicator, success.body.checkInExpirationTimeUtc );
          }
        } else {
          this.showErrorModal(ErrorCodesService.getErrorMessage(undefined, null));
        }
        this.loading = false;
        this.hideModal();
      },
      (err) => {
        this.loading = false;
        this.hideModal();
        this.showErrorModal(ErrorCodesService.getErrorMessage(undefined, null));
      }
    );
  }
  hideModal() {
    this.modalService.hideModal();
  }
  showErrorModal(errorMessage: string = null) {
    this.confirmModalService.show(
      errorMessage,
      '',
      '',
      'OK, Got It​',
      '',
      '',
      true
    );
  }
  showBreakfastModal(errorMessage: string = null) {
    this.confirmModalService.show(
      'Breakfast is not currently being cooked',
      '',
      'Breakfast is available between 11pm and 11am.',
      'Schedule a Breakfast Time​',
      'Remove Item',
      '',
      true,
      'showPickupTimePicker',
      'cancelOrderNoRedirect'
    );
  }
  getCheckinOptions(order: UserOrderInfo) {
    const url = this.isUserLoggedIn ? '/me/meals/orders/' + order?.orderNumber : '/meals/orders/' + order?.orderNumber +'/guestuser/' + order.guid;
    return this.proxy.httpGet(url + ApiRoutes.CHECKIN_OPTIONS);
  }

  public isSpaceSet(space: string, expiration: string) {
    this.spaceSetSubject.next({space: space, expiration: expiration });
  }  
}
